export default __webpack_public_path__ + "static/tickets-banner-8d9b21538783b123e6e9a74208b274b4.jpg";